import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { Typography, Box, Paper, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useNavigate } from "react-router-dom";

import Button from "../../components/common/Button";
import InputField from "../../components/common/new/InputField/InputField";
import { ToastAlertContext } from "../../config/providers/ToastAlert";
import { ROUTES } from "../../utils/constants";
import { AlertStatus } from "../../contants";

const axios = require("axios");

const endPoint = process.env.REACT_APP_API_BASE_URL;

function Forgot({ onClose }) {
  const [memberId, setMemberId] = useState("");
  const [isNumber, setIsNumber] = useState(true);
  const toast = useContext(ToastAlertContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { value } = e.target;
    setMemberId(value);
    setIsNumber(!Number.isNaN(Number(value)));
  };

  const validateInput = () => {
    if (!memberId) return "Please enter Member ID";
    if (!isNumber) return "Please enter a valid Member ID";
    return "";
  };

  // Exact Location & Address nikalne ke liye helper function

  // const getLocationDetails = async () => {
  //   try {
  //     // 1. Public IP fetch
  //     const ipRes = await fetch("https://api.ipify.org?format=json");
  //     const ipData = await ipRes.json();

  //     const currentIp = ipData.ip;

  //     console.log("IP Data:", ipData);

  //     // 2. IP -> Location
  //     const locationRes = await fetch(`https://ipwho.is/${currentIp}`);

  //     const locationData = await locationRes.json();

  //     console.log("IP Location:", locationData);

  //     if (!locationData.success) {
  //       return {
  //         clientIp: currentIp,
  //         latitude: null,
  //         longitude: null,
  //         address: "",
  //       };
  //     }

  //     const { latitude } = locationData;
  //     const { longitude } = locationData;

  //     // 3. Latitude + Longitude -> Full Address
  //     let address = "";

  //     try {
  //       const reverseRes = await fetch(
  //         `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}&addressdetails=1`,
  //         {
  //           headers: {
  //             Accept: "application/json",
  //           },
  //         }
  //       );

  //       const reverseData = await reverseRes.json();

  //       console.log("Reverse Geocoding:", reverseData);

  //       address = reverseData.display_name || "";
  //     } catch (addressError) {
  //       console.warn("Could not fetch address:", addressError);
  //     }

  //     // 4. Final location object
  //     return {
  //       clientIp: currentIp,

  //       latitude,
  //       longitude,

  //       address,

  //       city: locationData.city || "",
  //       state: locationData.region || "",
  //       country: locationData.country || "",
  //       pincode: locationData.postal || "",
  //     };
  //   } catch (error) {
  //     console.error("Error fetching location details:", error);

  //     return {
  //       clientIp: null,
  //       latitude: null,
  //       longitude: null,
  //       address: "",
  //       city: "",
  //       state: "",
  //       country: "",
  //       pincode: "",
  //     };
  //   }
  // };

  const getLocationDetails = async () => {
    try {
      // 1. Public IP fetch
      const ipRes = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipRes.json();
      const currentIp = ipData.ip;
      // 2. IP -> City, State, Country
      const locationRes = await fetch(`https://ipwho.is/${currentIp}`);
      const locationData = await locationRes.json();
      if (!locationData.success) {
        return {
          clientIp: currentIp,
          city: "",
          state: "",
          country: "",
        };
      }
      return {
        clientIp: currentIp,
        city: locationData.city || "",
        state: locationData.region || "",
        country: locationData.country || "",
      };
    } catch (error) {
      console.error("Error fetching location details:", error);
      return {
        clientIp: null,
        city: "",
        state: "",
        country: "",
      };
    }
  };

  // const postData = async () => {
  //   const validationError = validateInput();
  //   if (validationError) {
  //     toast.show(validationError, AlertStatus.ERROR);
  //     return;
  //   }

  //   try {
  //     const response = await axios.post(`${endPoint}/resetPassword`, {
  //       memberId,
  //     });

  //     toast.show(
  //       "OTP sent to your registered email and mobile number successfully",
  //       AlertStatus.SUCCESS
  //     );

  //     const authToken = response.headers["x-auth-token"];
  //     setTimeout(() => {
  //       navigate(`${ROUTES.CHANGE_PASSWORD.path}/${memberId}/${authToken}`);
  //     }, 2000);
  //   } catch (err) {
  //     const message =
  //       err.response?.data?.message || err.message || "Something went wrong";
  //     toast.show(message, AlertStatus.ERROR);
  //   }
  // };
  // const postData = async () => {
  //   const validationError = validateInput();
  //   if (validationError) {
  //     toast.show(validationError, AlertStatus.ERROR);
  //     return;
  //   }

  //   try {
  //     // 1. Exact Location & Address fetch karein
  //     const locationInfo = await getLocationDetails();

  //     // 2. Payload banayein jisme saari details hongi
  //     const payload = {
  //       memberId,
  //       clientIp: locationInfo.clientIp || null,
  //       address: locationInfo.address || null,
  //       city: locationInfo.city || null,
  //       state: locationInfo.state || null,
  //       country: locationInfo.country || null,
  //       pincode: locationInfo.pincode || null,
  //       latitude: locationInfo.latitude || null,
  //       longitude: locationInfo.longitude || null,
  //     };

  //     // 3. API ko poora payload bhejein
  //     const response = await axios.post(`${endPoint}/resetPassword`, payload);

  //     toast.show(
  //       "OTP sent to your registered email and mobile number successfully",
  //       AlertStatus.SUCCESS
  //     );

  //     const authToken = response.headers["x-auth-token"];
  //     setTimeout(() => {
  //       navigate(`${ROUTES.CHANGE_PASSWORD.path}/${memberId}/${authToken}`);
  //     }, 2000);
  //   } catch (err) {
  //     const message =
  //       err.response?.data?.message || err.message || "Something went wrong";
  //     toast.show(message, AlertStatus.ERROR);
  //   }
  // };

  const postData = async () => {
    const validationError = validateInput();
    if (validationError) {
      toast.show(validationError, AlertStatus.ERROR);
      return;
    }
    try {
      const locationInfo = await getLocationDetails();
      const payload = {
        memberId,
        clientIp: locationInfo.clientIp || null,
        city: locationInfo.city || null,
        state: locationInfo.state || null,
        country: locationInfo.country || null,
      };
      const response = await axios.post(`${endPoint}/resetPassword`, payload);
      toast.show(
        "OTP sent to your registered email and mobile number successfully",
        AlertStatus.SUCCESS
      );
      const authToken = response.headers["x-auth-token"];
      setTimeout(() => {
        navigate(`${ROUTES.CHANGE_PASSWORD.path}/${memberId}/${authToken}`);
      }, 2000);
    } catch (err) {
      const message =
        err.response?.data?.message || err.message || "Something went wrong";
      toast.show(message, AlertStatus.ERROR);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="78vh"
      bgcolor="rgba(85, 108, 214, 0.04)"
      px={2}
    >
      <Paper
        elevation={3}
        sx={{ maxWidth: 480, width: "100%", p: 4, borderRadius: 3 }}
      >
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography variant="h5" fontWeight="bold" textAlign="center" mb={2}>
          Reset Password
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          textAlign="center"
          mb={3}
        >
          Enter your Member ID and we will send you instructions to reset your
          password.
        </Typography>

        <InputField
          label="Member ID"
          Placeholder="Member ID"
          required
          name="memberId"
          type="text"
          value={memberId}
          onChange={handleChange}
          fullWidth
          sx={{
            mb: 2,
            backgroundColor: "#f2f2f2",
            borderRadius: 1,
            "& input": { padding: "12px" },
          }}
        />

        <Button
          sx={{
            fontSize: 14,
            fontWeight: 500,
            width: "100%",
            height: 50,
            borderRadius: 2,
            textTransform: "none",
            backgroundColor: "#00adf8",
            color: "#ffffff",
            mt: 1,
          }}
          variant="contained"
          label="Reset Password"
          onClick={postData}
        />

        <Typography variant="body2" mt={3} textAlign="center" color="primary">
          <Link to="/" onClick={onClose} style={{ textDecoration: "none" }}>
            Return to Login
          </Link>
        </Typography>
      </Paper>
    </Box>
  );
}

Forgot.propTypes = {
  onClose: PropTypes.func,
};

Forgot.defaultProps = {
  onClose: () => {},
};

export default Forgot;
